import { useState } from 'react'
import './TourPanel.css'
import { Link } from 'react-router-dom'

const STEPS = [
  'Dashboard overview',
  'Create a role pipeline',
  'Find & engage executives',
  'Collaborate as a team',
  'Make confident decisions',
]

/**
 * The welcome/tour overlay.
 *
 * In the locked HTML this moved itself around the DOM; here it stays put and
 * only toggles a class — the CSS does the rest. It must remain a child of
 * `.lower` so that docking places it in the right rail; while floating it is
 * position:fixed and therefore out of the grid's flow anyway.
 */
export function TourPanel() {
  const [docked, setDocked] = useState(false)

  return (
    <aside className={`ov ov-tour${docked ? ' at-bottom' : ''}`} role="dialog" aria-label="Welcome tour">
      <div className="ov-h" style={{ alignItems: 'flex-start' }}>
        <span className="tour-h">Welcome to NexExec<br />Company Dashboard</span>
        <button
          className="x"
          type="button"
          onClick={() => setDocked((d) => !d)}
          aria-label={docked ? 'Return panel to the top of the page' : 'Move to bottom of page'}
        >
          {docked ? (
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" aria-hidden="true">
              <rect x="4.5" y="4.5" width="15" height="15" rx="3.5" stroke="currentColor" strokeWidth="2" />
              <path d="M17 7 7 17V7z" fill="currentColor" />
            </svg>
          ) : (
            <svg width="13" height="13" viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="2.2" aria-hidden="true">
              <path d="M5 10h10" />
            </svg>
          )}
        </button>
      </div>

      <div className="ov-b">
        <div className="vid">
          <button className="play" type="button" aria-label="Play overview">
            <svg width="14" height="14" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
              <path d="M6.5 4 16 10l-9.5 6z" />
            </svg>
          </button>
          <span className="dur tnum" aria-hidden="true">01:30</span>
        </div>

        <p className="pv-p">Take a quick tour to get oriented</p>
        <div className="tl">
          {STEPS.map((step, i) => (
            <span className="tli" key={step}>
              <span className="tln">{i + 1}</span>
              {step}
            </span>
          ))}
        </div>

        <div className="tb">
          <Link className="btn btn-teal btn-b" to="/help">Start Tour</Link>
          <Link className="btn btn-b" to="/help">Watch Overview</Link>
          {/* "Skip for Now" only docks — it never restores. Locked behavior. */}
          <button
            className="btn btn-b"
            type="button"
            style={{ borderColor: 'transparent', color: 'var(--ink-2)' }}
            onClick={() => setDocked(true)}
          >
            Skip for Now
          </button>
        </div>
      </div>
    </aside>
  )
}
